import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { LOCAL_STORAGE_KEY } from "../constants";

const LoginSelection = () => {
  const history = useHistory();

  useEffect(() => {
    const userInfo = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (userInfo) {
      history.push("/");
    }
  }, [history]);

  return (
    <>
      {/* Main Container */}
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #1e293b, #0f172a)",
        }}
      >
        {/* Card */}
        <div
          style={{
            width: "350px",
            background: "#fff",
            padding: "40px 30px",
            borderRadius: "14px",
            boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
            textAlign: "center",
          }}
        >
          {/* Title */}
          <h2
            style={{
              margin: "0",
              fontSize: "22px",
              fontWeight: "700",
              color: "#0f172a",
            }}
          >
            Hotel Managment System
          </h2>

          {/* Subtitle */}
          <p
            style={{
              marginTop: "6px",
              marginBottom: "30px",
              fontSize: "14px",
              color: "#64748b",
            }}
          >
            Select Login Type
          </p>

          {/* Admin Button */}
          <button
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "8px",
              border: "none",
              background: "#2563eb",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              marginBottom: "14px",
              transition: "0.2s",
            }}
            onMouseOver={(e) =>
              (e.target.style.background = "#1d4ed8")
            }
            onMouseOut={(e) =>
              (e.target.style.background = "#2563eb")
            }
            onClick={() => history.push("/admin/login")}
          >
            Admin Login
          </button>

          {/* Member Button */}
          <button
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "8px",
              border: "none",
              background: "#16a34a",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) =>
              (e.target.style.background = "#15803d")
            }
            onMouseOut={(e) =>
              (e.target.style.background = "#16a34a")
            }
            onClick={() => history.push("/member/login")}
          >
            Member Login
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer
        style={{
          textAlign: "center",
          padding: "12px",
          fontSize: "13px",
          color: "#94a3b8",
          background: "#0f172a",
        }}
      >
        All Rights Reserved ©
      </footer>
    </>
  );
};

export default LoginSelection;
